<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>Iniciar Sesión</mat-card-title>
      <mat-card-subtitle>Panel Administrativo Workbi</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <!-- Email -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            placeholder="usuario@workbi.com"
            autocomplete="email"
          />
          <mat-icon matPrefix>email</mat-icon>
          <mat-error *ngIf="email?.hasError('required')">
            El email es requerido
          </mat-error>
          <mat-error *ngIf="email?.hasError('email')">
            Email inválido
          </mat-error>
        </mat-form-field>

        <!-- Password -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Contraseña</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            placeholder="••••••••"
            autocomplete="current-password"
          />
          <mat-icon matPrefix>lock</mat-icon>
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hidePassword"
          >
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="password?.hasError('required')">
            La contraseña es requerida
          </mat-error>
          <mat-error *ngIf="password?.hasError('minlength')">
            Mínimo 6 caracteres
          </mat-error>
        </mat-form-field>

        <!-- Error Message -->
        <div *ngIf="errorMessage" class="error-message">
          <mat-icon>error</mat-icon>
          <span>{{ errorMessage }}</span>
        </div>

        <!-- Submit Button -->
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="full-width submit-button"
          [disabled]="loginForm.invalid || loading"
        >
          <mat-spinner *ngIf="loading" diameter="20" class="button-spinner"></mat-spinner>
          <span *ngIf="!loading">Iniciar Sesión</span>
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
